import { graphql } from "@opensea/graphql"

export const useToggleWatchTokenFragment = graphql(`
  fragment useToggleWatchToken on Currency {
    contractAddress
    chainIdentifier
    name
    symbol
  }
`)
